document.addEventListener("alpine:init", () => {
  // console.log('alpine:init');
  Alpine.data("bundles", () => ({
    loaded: false,
    init() {
      this.loaded = true;
      // Set initial selling plan if available
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const selectElement = document.querySelector(
        '[name="frequency_selling_plan"]'
      );
      if (selectElement) {
        this.currentSellingPlan = selectElement.value;
        // console.log(this.currentSellingPlan, 'this.currentSellingPlan');
      }

      if (searchParams.get("collection")) {
        this.setCollection(searchParams.get("collection"));
      }
      if (searchParams.get("selected_product")) {
        this.setSelectedProduct(Number(searchParams.get("selected_product")));
      }
    },

    selectedCollection: "all",
    selectedProduct: null,
    isSubscription: false,
    maxProgressBarQty: 2,
    boxDiscountType: "percent",
    subscriptionDiscount: 10,
    bundleDiscount: 10,
    currentSellingPlan: null,
    savingPercentage: null,
    savingAmount: null,
    slots: [],
    totalSlotsQuantity: 0,
    maxQty: 99,
    minQty: 0,
    progressBarWidth: 0,
    selectedFilter: "*",
    bundleProducts: window.bundleProducts,
    originalTotalPrice: 0,
    originalTotalPriceWithBundleSavings: 0,
    totalPrice: 0,
    totalPriceWithDiscount: 0,
    disableAddToCartButton: false,
    freeShippingThreshold: 4000,
    freeShippingRemaining: 0,
    isScrolledToBottom: false,
    isScrolledToTheProduct: false,

    setFilter(filter) {
      this.selectedFilter = filter;
    },

    setCollection(collectionId) {
      this.selectedCollection = collectionId;
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      searchParams.set("collection", collectionId);
      url.search = searchParams.toString();
      window.history.pushState({}, "", url);
    },

    setSelectedProduct(productId) {
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      if (this.selectedProduct === productId) {
        this.selectedProduct = null;
        searchParams.delete("selected_product");
      } else {
        this.selectedProduct = Number(productId);
        searchParams.set("selected_product", this.selectedProduct);
      }

      if (!this.isScrolledToTheProduct) {
        this.scrollToTheProduct(this.selectedProduct);
      }

      url.search = searchParams.toString();
      window.history.pushState({}, "", url);

      this.$dispatch('bundle-product-changed', { productId: this.selectedProduct });
    },

    /**
     * Scroll to the product in the bundle on page load
     * @param {number} productId - The product ID
     */
    scrollToTheProduct(productId) {
      this.isScrolledToTheProduct = true;
      if (this.selectedProduct !== productId) { return; }

      const product = document.querySelector(`[data-bundle-product-id="${this.selectedProduct}"]`);
      if (!product) { return; }

      this.$el?.querySelector('[data-scroll-wrapper]')?.scrollTo({
        top: product.offsetTop,
        behavior: 'instant'
      });
    },

    updatePrices() {
      // console.log('updatePrices this.slots', this.slots);
      if (!this.slots || !this.slots.length) return;

      this.originalTotalPrice = this.slots.reduce(
        (accumulator, currentObject) => {
          return accumulator + currentObject.price * currentObject.quantity;
        },
        0
      );
      // console.log('this.originalTotalPrice', this.originalTotalPrice);

      const bundleDiscount =
        this.totalSlotsQuantity > 1 ? this.bundleDiscount : 0;
      // console.log('bundleDiscount', bundleDiscount);

      // Calculate discounted prices with proper rounding at each step
      const subscriptionMultiplier = 1 - this.subscriptionDiscount / 100;
      const bundleMultiplier = 1 - bundleDiscount / 100;
      const bundleDiscountAmount = bundleDiscount * 100;

      if (this.boxDiscountType === "fixed") {
        this.totalPriceWithDiscount = Math.round(
          this.originalTotalPrice * subscriptionMultiplier -
            bundleDiscountAmount
        );
        this.originalTotalPriceWithBundleSavings =
          this.originalTotalPrice - bundleDiscountAmount;

        if (this.currentSellingPlan) {
          this.totalPrice = Math.round(
            this.originalTotalPrice * subscriptionMultiplier -
              bundleDiscountAmount
          );
          this.savingPercentage = bundleDiscount + this.subscriptionDiscount;
        } else {
          this.totalPrice = Math.round(
            this.originalTotalPrice - bundleDiscountAmount
          );
          this.savingPercentage = bundleDiscount;
        }
      } else if (this.boxDiscountType === "percent") {
        this.totalPriceWithDiscount = Math.round(
          this.originalTotalPrice * subscriptionMultiplier * bundleMultiplier
        );
        this.originalTotalPriceWithBundleSavings =
          this.originalTotalPrice * bundleMultiplier;
        if (this.currentSellingPlan) {
          this.totalPrice = Math.round(
            this.originalTotalPrice * subscriptionMultiplier * bundleMultiplier
          );
          this.savingPercentage = bundleDiscount + this.subscriptionDiscount;
        } else {
          this.totalPrice = Math.round(
            this.originalTotalPrice * bundleMultiplier
          );
          this.savingPercentage = bundleDiscount;
        }
      }

      this.savingAmount = Math.round(this.originalTotalPrice - this.totalPrice);
    },

    getSavingPercentage() {
      if (this.totalSlotsQuantity > 1) {
        return this.bundleDiscount + this.subscriptionDiscount;
      } else {
        return this.subscriptionDiscount;
      }
    },

    getSubscriptionMessage() {
      if (this.totalSlotsQuantity === 0) {
        return "Save 10% when you subscribe";
      } else {
        return "Save an extra 10% off 2+ Packs";
      }
    },

    moneyFormat(price) {
      // const currency = window.Shopify?.currency?.active || 'USD';
      const currency = "USD";
      const symbol = this._getCurrencySymbol(currency);
      const numericPrice = (+price / 100).toFixed(2);
      return `${symbol}${numericPrice}`;
    },

    onUpdateSlots() {
      this.countSlotsQuantity();
      this.updatePrices();
      this.updateProgressBar();
      this.updateProgressBarWidth();
    },

    updateSlots(productId, variantId, qty) {
      const slotObj = this.bundleProducts.find(
        (product) => product.productId === productId
      );
      const foundSlot = this.slots.find((slot) => slot.productId === productId);

      if (foundSlot) {
        foundSlot.quantity = qty;
      } else {
        slotObj.quantity = qty;
        this.slots.push(slotObj);
      }

      this.onUpdateSlots();
    },

    countSlotsQuantity() {
      if (!this.slots || !this.slots.length) return 0;
      this.totalSlotsQuantity = 0;
      this.slots.forEach((slot) => {
        this.totalSlotsQuantity += slot.quantity;
      });
    },

    updateSellingPlan(value) {
      this.currentSellingPlan = value;
      console.log(this.currentSellingPlan, "this.currentSellingPlan");
    },

    updateProgressBarWidth() {
      if (!this.slots || !this.slots.length) {
        this.progressBarWidth = 0;
        this.totalSlotsQuantity = 0;
      } else {
        if (this.isSubscription) {
          const step = (100 / this.maxProgressBarQty).toFixed(2);
          const amountInPercent = this.totalSlotsQuantity * step;
          this.progressBarWidth = amountInPercent > 100 ? 100 : amountInPercent;
        } else {
          // Calculate progress based on remaining amount needed for free shipping
          const currentAmount = this.originalTotalPrice;
          // console.log(currentAmount, 'currentAmount');
          const remainingAmount = Math.max(
            0,
            this.freeShippingThreshold - currentAmount
          );
          const progressPercentage = Math.min(
            100,
            ((this.freeShippingThreshold - remainingAmount) /
              this.freeShippingThreshold) *
              100
          );
          this.freeShippingRemaining = remainingAmount;
          this.progressBarWidth = progressPercentage;
        }
      }
    },

    updateProgressBar() {
      if (this.isSubscription) {
        const totalSlotQTY = this.totalSlotsQuantity;
        const subscriptionBundleMessages = [
          {
            qty: 0,
            message: "Add 1 pack to save 10%",
          },
          {
            qty: 1,
            message: "Add 1 more pack to save an extra 10%",
          },
          {
            qty: 2,
            message: "Maximum savings unlocked!",
          },
        ];

        const activeMessage = subscriptionBundleMessages.reduce(
          (highest, current) => {
            if (
              +totalSlotQTY >= +current.qty &&
              (!highest || current.qty >= highest.qty)
            ) {
              return current;
            }
            return highest;
          },
          null
        );

        if (!activeMessage) {
          // Return the first tier's message if no threshold is met
          return subscriptionBundleMessages[0].message;
        }
        return activeMessage.message;
      } else {
        if (this.originalTotalPrice == 0) {
          return "Add $40+ or subscribe to get Free Shipping";
        } else if (this.freeShippingRemaining > 0) {
          return (
            "Add " +
            this.moneyFormat(this.freeShippingRemaining) +
            " to get Free Shipping"
          );
        } else if (this.freeShippingRemaining == 0) {
          return "Free Shipping unlocked!";
        }
      }
    },

    updateProgressBarDotPosition() {
      switch (this.totalSlotsQuantity) {
        case 0:
          return "left: 0";
        case 1:
          return `left: calc(${this.progressBarWidth}% - 8px)`;
        default:
          return `left: calc(${this.progressBarWidth}% - 16px)`;
      }
    },

    updateSavingsTextPosition() {
      if (!this.isSubscription) return;
      switch (this.totalSlotsQuantity) {
        case 0:
          return "display: none;";
        case 1:
          return `left: calc(${this.progressBarWidth}% - 80px)`;
        default:
          return `left: calc(${this.progressBarWidth}% - 155px)`;
      }
    },

    addToCart() {
      if (!this.slots || !this.totalSlotsQuantity) return;
      this.disableAddToCartButton = true;
      const itemsForCart = [];
      if (this.isSubscription) {
        this.slots.forEach((slot) => {
          itemsForCart.push({
            id: slot.variantId,
            quantity: slot.quantity,
            selling_plan: parseInt(this.currentSellingPlan),
            // properties: {
            //     Box: 'Bundle'
            // }
          });
        });
      } else {
        this.slots.forEach((slot) => {
          itemsForCart.push({
            id: slot.variantId,
            quantity: slot.quantity,
          });
        });
      }

      console.log(itemsForCart, "itemsForCart");

      CartJS.addItems(itemsForCart, {
        success: (data, textStatus, jqXHR) => {
          console.log("Added!");
          // console.log(data, 'data');
          ShopifyAPI.updateCartNote();
          setTimeout(() => {
            const cart_btn = document.querySelector(
              '[data-action="toggle-cart"]'
            );
            if (cart_btn) {
              cart_btn.click();
            }
            this.disableAddToCartButton = false;
          }, 1000);
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.log(jqXHR, textStatus, errorThrown);
          this.disableAddToCartButton = false;
        },
      });
    },

    _getCurrencySymbol(currencyCode) {
      const currencySymbols = {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        JPY: "¥", // Japanese Yen
        GBP: "£", // British Pound Sterling
        CNY: "¥", // Chinese Yuan
        AUD: "$", // Australian Dollar
        CAD: "C$", // Canadian Dollar
        CHF: "Fr", // Swiss Franc
        HKD: "HK$", // Hong Kong Dollar
        SGD: "S$", // Singapore Dollar,
        PHP: "₱", // Philippine Peso
      };
      return currencySymbols[currencyCode.toUpperCase()] || currencyCode;
    },

    openNutritionalFactsModal(productId) {
      console.log(productId, "productId");
      const productData = this.bundleProducts.find(
        (product) => product.productId === productId
      );
      console.log(productData, "productData");
      if (productData) {
        const modal = document.querySelector("[data-product-modal]");
        const modalProductTitle = modal.querySelector(
          "[data-modal-product-title]"
        );
        const modalProductDescription = modal.querySelector(
          "[data-modal-product-description]"
        );
        const modalProductImage = modal.querySelector(
          "[data-modal-product-image]"
        );
        const modalProductNutritionImage = modal.querySelector(
          "[data-modal-nutrition-image]"
        );
        const modalAddToBundle = modal.querySelector("[data-modal-add-bundle]");
        if (modalProductTitle) {
          modalProductTitle.innerHTML = productData.title
            ? productData.title
            : "";
        }
        if (modalProductDescription) {
          modalProductDescription.innerHTML = productData.description
            ? productData.description
            : "";
        }
        if (modalProductImage) {
          modalProductImage.src = productData.image ? productData.image : "";
        }
        if (modalProductNutritionImage) {
          modalProductNutritionImage.src = productData.nutritional_facts_image
            ? productData.nutritional_facts_image
            : "";
        }
        if (modalAddToBundle) {
          modalAddToBundle.setAttribute("data-bundle-item", productId);
        }
        openProductModal();
      }
    },

    isMaxQuantityReached() {
      return this.totalSlotsQuantity >= this.maxQty;
    },
  }));
});
